<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="pageKey"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Customer"
        :baseView="baseView"
        :createModeIsEditMode="true"
        :primaryLabel="model.CustomerName"
        :secondaryLabel="model.CustomerCode"
        recordType="Customer"
        v-if="model.CustomerCode"
      />
    </template>
    <div class="css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <dx-data-grid
              :data-source="dataSourceConfig"
              ref="freightChargeGrid"
              :columns="columns"
              :height="gridHeight - 20"
              @selection-changed="onSelectionChanged"
              @toolbar-preparing="onToolbarPreparing($event)"
              @content-ready="addGridNoResults($event)"
              v-if="model.CustomerCode"
              :selection="{ mode: 'single' }"
            >
              <DxPaging :page-size="50" :enabled="false" />
              <DxPager :visible="false" />

              <DxScrolling
                :mode="'virtual'"
                :row-rendering-mode="'virtual'"
                :preloadEnabled="true"
              />
              <template #default-cell-template="{ data }">
                <DxCheckBox
                  v-if="data.data.LineNo === 1"
                  :value="true"
                  :read-only="true"
                />
                <DxCheckBox
                  v-else-if="data.data.LineNo != 1"
                  :read-only="
                    !formsConfig.editableOption || baseView.mode != 'review'
                  "
                  @value-changed="changeDefaultAddress(data.data)"
                />
              </template>
            </dx-data-grid>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem #default location="before" locate-in-menu="never">
              <!-- <div class="toolbar-label">
                <span class="text-primary">{{ model.CompanyName }}</span>
              </div> -->

              <GcDescriptionCodeCellTemplate
                :description="model.CompanyName"
                :code="deliveryAddressSecondaryLabel"
              />
            </DxItem>
            <DxItem
              widget="dxForm"
              location="after"
              :options="{
                formData: model,
                items: toolbarActiveItems,
                validationGroup: 'toolbarForm-2',
                labelLocation: 'left',
                customizeItem: customizeItem,
              }"
              locate-in-menu="auto"
            ></DxItem>
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />

            <DxItem
              :options="toolbar.delete"
              location="after"
              locate-in-menu="auto"
              widget="dxDropDownButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            />

            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
              :visible="formsConfig.editableOption"
            />

            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />

            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings">
            <form>
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :items="items"
                @content-ready="onFormContentReady"
              >
                <template #unitOfMeasure="{ data }">
                  <div class="custom-auto-complete">
                    <span class="auto-complete-primary">{{
                      data.Description
                    }}</span>
                    <span class="auto-complete-secondary">{{ data.Code }}</span>
                  </div>
                </template>
                <template #deliveryAddressTemplate="{ data }">
                  <div class="custom-auto-complete data-grid">
                    <span class="auto-complete-primary">{{
                      data.CompanyName
                    }}</span>
                    <div class="auto-complete-secondary no-padding">
                      <span v-if="data.PhysicalAddressStreetLine1 != ''">{{
                        data.PhysicalAddressStreetLine1
                      }}</span>
                      <span v-if="data.PhysicalAddressStreetLine2 != ''">
                        {{ data.PhysicalAddressStreetLine2 }}
                      </span>
                      <span v-if="data.PhysicalAddressSuburb != ''">
                        {{ data.PhysicalAddressSuburb }}
                      </span>
                      <span v-if="data.PhysicalAddressState != ''">
                        {{ data.PhysicalAddressState }}
                      </span>
                      <span v-if="data.PhysicalAddressPostcode != ''">
                        {{ data.PhysicalAddressPostcode }}
                      </span>
                    </div>
                  </div>
                </template>
              </DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import { CustomerFreightChargeService } from "../../_services/api/accounts/customer-freight-charge.service";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { CustomerDeliveryAddressService } from "../../_services/api/customers/customer-delivery-address.service";

import { UnitOfMeasureService } from "../../_services/api/settings/products/unit-of-measure.service";

import BaseViewMixin from "../../v1/_mixins/base.view";
import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";
import validationEngine from "devextreme/ui/validation_engine";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

export default {
  mixins: [BaseViewMixin, CustomerTabsMixin],
  created() {
    this.selectedIndex = 5;
  },
  data() {
    return {
      toolbar: {
        close: {
          tabIndex: -1,
          icon: "close",
          onClick: this.close,
        },
        edit: {
          icon: "edit",
          tabIndex: -1,
          onClick: () => {
            this.$router.push({
              path: `/customer-freight-charge/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          tabIndex: -1,
          validationGroup: "formsData",
          onClick: (e) => {
            this.saveCustomerSalesContractFreightCharge(e);
          },
        },
        delete: {
          tabIndex: -1,
          items: [{ menuText: "Delete" }, { menuText: "Delete All Addresses" }],
          keyExpr: "menuText",
          displayExpr: "menuText",
          icon: "trash",
          showArrowIcon: false,
          dropDownOptions: {
            width: "200px",
          },
          stylingMode: "text",
          onItemClick: async (e) => {
            if (e.itemData.menuText == "Delete") {
              this.deleteCustomerSalesContractFreightCharge(false);
            } else if (e.itemData.menuText == "Delete All Addresses") {
              this.deleteCustomerSalesContractFreightCharge(true);
            }
          },
        },
        delete1: {
          tabIndex: -1,
          icon: "trash",
          validationGroup: "formsData",
          onClick: (e) => {
            this.deleteCustomerSalesContractFreightCharge(e);
          },
        },
        audit: {
          icon: "clock",
          tabIndex: -1,
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },

      model: {
        CompanyName: "",
        CustomerCode: "",
        CustomerName: "",
        FreightCharge: 0,
        DeliveryCode: null,
        UnitOfMeasureCode: null,
        AllDeliveryAddresses: false,
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        RecordId: "00000000-0000-0000-0000-000000000000",

        PhysicalAddressCountry: "",
        PhysicalAddressPostcode: "",
        PhysicalAddressState: "",
        PhysicalAddressStreetLine1: "",
        PhysicalAddressStreetLine2: "",
        PhysicalAddressSuburb: "",
      },
      noDataMessage: {
        addNew: {
          class: "add-new",
          title: "No Freight Charges Defined",
          message: "Get Started, Add a Freight Charge",
        },
      },
    };
  },
  computed: {
    toolbarActiveItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "AllDeliveryAddresses",
              label: { text: "All Delivery Addresses" },
              editorType: "dxSwitch",
              disabled: false,
              readOnly: false,
            },
          ],
        },
      ];
    },
    deliveryAddressSecondaryLabel() {
      let result = "";

      if (this.model.PhysicalAddressStreetLine1)
        result += this.model.PhysicalAddressStreetLine1 + ", ";

      if (this.model.PhysicalAddressStreetLine2)
        result += this.model.PhysicalAddressStreetLine2 + ", ";

      if (this.model.PhysicalAddressSuburb)
        result += this.model.PhysicalAddressSuburb + ", ";

      if (this.model.PhysicalAddressPostcode)
        result += this.model.PhysicalAddressPostcode + ", ";

      if (this.model.PhysicalAddressCountry)
        result += this.model.PhysicalAddressCountry + ", ";

      result = result.replace(new RegExp(", " + "$"), "");
      return result;
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Delivery",
          dataField: "DeliveryCompanyName",
          gcType: "String",
          gcSubType: "PrimaryRecord",
        },
        {
          gcLabel: "UM",
          dataField: "UnitOfMeasureCode",
          gcType: "String",
          width: ColumnWidth.UnitOfMeasure.width,
          maxWidth: ColumnWidth.UnitOfMeasure.minWidth,
        },
        {
          gcLabel: "Charge",
          dataField: "FreightCharge",
          gcType: "Decimal-4-2C",
          allowSearch: false,
          setWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
          maxWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
        },
        {
          gcLabel: "State",
          dataField: "DeliveryState",
          gcType: "String",
          width: 120,
          maxWidth: 120,
        },
      ]);
    },
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "DeliveryCode",
              validationRules: [
                {
                  type: "required",
                  message: "Delivery address is required",
                },
              ],
              editorType: "dxSelectBox",
              // editorType:                this.baseView.mode != "review" ? "dxTextBox" : "dxSelectBox",
              visible: this.baseView.mode == "create",
              editorOptions: {
                dataSource: CustomerDeliveryAddressService.dataSourceConfig(
                  "api/CustomerDeliveryAddress",
                  {
                    select: [
                      "CompanyName",
                      "PhysicalAddressStreetLine1",
                      "PhysicalAddressStreetLine2",
                      "PhysicalAddressSuburb",
                      "PhysicalAddressState",
                      "PhysicalAddressPostcode",
                      "PhysicalAddressCountry",
                      "RecordId",
                      "LineNo",
                      "Inactive",
                    ],
                    key: "RecordId",
                    filter: [
                      ["CustomerCode", "=", this.model.CustomerCode],
                      "and",
                      ["Inactive", "=", "N"],
                    ],
                  }
                ),
                valueExpr: "LineNo",
                displayExpr: "CompanyName",
                searchExpr: ["CustomerCode", "CompanyName"],
                searchMode: "contains",
                showClearButton: false,
                itemTemplate: "deliveryAddressTemplate",
                acceptCustomValue: true,
                onCustomItemCreating: this.customItemCreating,

                searchEnabled: true,
                openOnFieldClick: true,
                // onItemClick: this.onDeliveryAddressChanged.bind(this),
                onFocusIn: this.isTablet
                  ? this.onFocusEvent.bind(this, "DeliverTo")
                  : null,
              },
              label: {
                text: "Delivery Address",
              },
            },
            {
              dataField: "UnitOfMeasureCode",
              validationRules: [
                {
                  type: "required",
                  message: "UM is required",
                },
                {
                  type: "async",
                  validationCallback: this.unitOfMeasureCodeExistsRuleCallback,
                  message: "Unit of Measure does not exist",
                },
              ],
              editorType:
                this.baseView.mode != "review" ? "dxSelectBox" : "dxTextBox",
              editorOptions: {
                dataSource: UnitOfMeasureService.dataSourceConfig(
                  "api/UnitOfMeasure",
                  {
                    select: ["Description", "Code"],
                    filter: ["Inactive", "=", false],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                searchExpr: ["Description", "Code"],
                searchMode: "contains",
                showClearButton: true,
                itemTemplate: "unitOfMeasure",
                searchEnabled: true,
                displayExpr: "Code",
              },
              label: {
                text: "UM",
              },
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FreightCharge",
                  label: { text: "Charge" },
                  editorType: "dxNumberBox",
                  editorOptions: {
                    format: this.getDecimalFormatByCode(12).Format,
                    onChange: this.onConversionFactorChange,
                  },
                  disabled: false,
                  validationRules: [
                    {
                      type: "required",
                      message: "Charge is required",
                    },
                    {
                      type: "range",
                      message: "Charge must be between -9,999.99 and 9,999.99",
                      min: -9999.99,
                      max: 9999.99,
                    },
                  ],
                },
              ],
            },
            // {
            //   itemType: "group",
            //   caption: "",
            //   items: [
            //     {
            //       dataField: "AllDeliveryAddresses",
            //       label: { text: "All Delivery Addresses" },
            //       editorType: "dxSwitch",
            //       disabled: false,
            //       readOnly: false,
            //     },
            //   ],
            // },
          ],
        },
      ];

      return formFields;
    },
    dataSourceConfig() {
      return CustomerFreightChargeService.dataSourceConfig(
        "api/CustomerSalesContractFreightChargeList",
        {
          select: [
            "DeliveryCompanyName",
            "CustomerCode",
            "DeliveryCode",
            "FreightCharge",
            "UnitOfMeasureCode",
            "DeliveryState",
            "RecordId",
          ],
          // sort: [{ selector: "LineNo", desc: false }],
          filter: [["CustomerCode", "=", this.model.CustomerCode]],
        }
      );
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
    showRightContainer() {
      setTimeout(() => {
        let grid = this.$refs["freightChargeGrid"].instance;
        grid.updateDimensions();
      }, 10);
    },
  },
  methods: {
    onFormContentReady(e) {
      if (e) {
        validationEngine.validateGroup(this.formsConfig.validationGroup);
        setTimeout(() => {
          if (this.baseView.mode == "create")
            e.component.instance().getEditor("DeliveryCode").focus();
          if (this.baseView.mode == "edit")
            e.component.instance().getEditor("UnitOfMeasureCode").focus();
        }, 100);
      }
    },
    async close() {
      if (this.baseView.mode == "create" || this.baseView.mode == "edit") {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          let grid = this.$refs["freightChargeGrid"].instance;
          grid.clearSelection();

          this.baseView.id = this.model.CustomerCode;
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-freight-charge/${this.baseView.id}`,
          });
        } else {
          this.next(false);
        }
      } else {
        let grid = this.$refs["freightChargeGrid"].instance;
        grid.clearSelection();

        this.baseView.id = this.model.CustomerCode;
        this.setIgnoreRouteChangeConfirmation();
        this.$router.push({
          path: `/customer-freight-charge/${this.baseView.id}`,
        });
      }
    },
    backButtonFunction() {
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/customer",
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" && item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            onClick: async () => {
              if (this.baseView.mode == "edit") {
                let confirmLeaving = await this.$confirm(
                  "You have unsaved changes. Are you sure you want to leave?",
                  "Unsaved changes"
                );

                if (confirmLeaving) {
                  this.setIgnoreRouteChangeConfirmation();
                  this.createNewFreight();
                }
              } else {
                this.createNewFreight();
              }
            },
          },
        },
        searchPanel,

        columnChooserButton
      );
    },
    createNewFreight() {
      this.model.FreightCharge = 0;
      this.model.DeliveryCode = null;
      this.model.UnitOfMeasureCode = null;
      this.model.AllDeliveryAddresses = false;

      this.model.CompanyName = "";
      this.model.PhysicalAddressCountry = "";
      this.model.PhysicalAddressPostcode = "";
      this.model.PhysicalAddressState = "";
      this.model.PhysicalAddressStreetLine1 = "";
      this.model.PhysicalAddressStreetLine2 = "";
      this.model.PhysicalAddressSuburb = "";
      this.model.RecordId = "00000000-0000-0000-0000-000000000000";
      this.model.DateChanged = "";
      this.model.DateCreated = "";
      this.model.ChangedBy = "";
      this.model.CreatedBy = "";

      this.baseView.id = this.model.CustomerCode;

      this.$router.push({
        path: `/customer-freight-charge/create/${this.baseView.id}`,
      });
    },
    handleLocalRouteChange() {
      let that = this;
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        this.showLoading(true);
        this.model.RecordId = this.baseView.id;
        this.getRecord().then((response) => {
          if (response.data.value.length > 0) {
            this.model.DeliveryCode = response.data.value[0].DeliveryCode;
            this.model.CustomerCode = response.data.value[0].CustomerCode;
            this.model.FreightCharge = response.data.value[0].FreightCharge;
            this.model.UnitOfMeasureCode =
              response.data.value[0].UnitOfMeasureCode;

            this.model.DateChanged = response.data.value[0].DateChanged;
            this.model.DateCreated = response.data.value[0].DateCreated;
            this.model.ChangedBy = response.data.value[0].ChangedBy;
            this.model.CreatedBy = response.data.value[0].CreatedBy;

            CustomerDeliveryAddressService.getByCodeAndLineNo(
              this.model.CustomerCode,
              this.model.DeliveryCode
            ).then((res) => {
              that.model.CompanyName = res.data.value[0].CompanyName;
              that.model.PhysicalAddressCountry =
                res.data.value[0].PhysicalAddressCountry;
              that.model.PhysicalAddressPostcode =
                res.data.value[0].PhysicalAddressPostcode;
              that.model.PhysicalAddressState =
                res.data.value[0].PhysicalAddressState;
              that.model.PhysicalAddressStreetLine1 =
                res.data.value[0].PhysicalAddressStreetLine1;
              that.model.PhysicalAddressStreetLine2 =
                res.data.value[0].PhysicalAddressStreetLine2;
              that.model.PhysicalAddressSuburb =
                res.data.value[0].PhysicalAddressSuburb;
            });
          }
          this.showLoading(false);
        });
      } else {
        CustomerService.getByCode(that.baseView.id).then((response) => {
          if (response.data.value.length > 0) {
            that.model.CustomerCode = response.data.value[0].Code;
            that.model.CustomerName = response.data.value[0].Name;

            // that.refreshView();
          }
        });
      }
    },
    async getRecord() {
      return CustomerFreightChargeService.getByRecordId(this.baseView.id);
    },
    onSelectionChanged({ selectedRowsData }) {
      if (selectedRowsData.length == 0) {
        return;
      }

      this.baseView.id = selectedRowsData[0].RecordId;
      this.$router.push({
        path: `/customer-freight-charge/review/${selectedRowsData[0].RecordId}`,
      });
      this.baseView.tempId = this.model.CustomerCode;
    },
    async changeDefaultAddress(record) {
      let confirmYes = await this.$confirm(
        "Do you wish to change the default address?",
        "Default Address"
      );

      if (confirmYes) {
        let that = this;

        // eslint-disable-next-line no-debugger
        await CustomerDeliveryAddressService.changeDefault({
          CustomerCode: record.CustomerCode,
          RecordId: record.RecordId,
        })
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            that.showLoading(false);
            that.close();
            let grid = this.$refs["freightChargeGrid"].instance;
            grid.refresh();
          })
          .catch((error) => {
            this.displayServerError(
              error,
              "Customer Delivery Address set default failed"
            );
          });
      }
    },
    async deleteCustomerSalesContractFreightCharge(
      deleteFreightForAllDeliveryAddesses
    ) {
      let that = this;

      let confirmDeletion = await this.$confirm(
        `Are you sure you want to delete record for ${this.model.CompanyName}?`,
        "Delete Freight Charge"
      );

      if (confirmDeletion) {
        this.showLoading(true);
        await CustomerFreightChargeService.delete({
          RecordId: this.model.RecordId,
          AllDeliveryAddresses: deleteFreightForAllDeliveryAddesses ? "Y" : "N",
          CustomerCode: this.model.CustomerCode,
        })
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            that.showLoading(false);
            that.close();
            let grid = this.$refs["freightChargeGrid"].instance;
            grid.refresh();
          })
          .catch((error) => {
            this.displayServerError(
              error,
              "Customer Freight Charge delete failed"
            );
          });
      }
    },
    async saveCustomerSalesContractFreightCharge(e) {
      const result = await e.validationGroup.validate();
      if (!result.isValid) {
        this.addErrorMessagesFromValidationResult(result);
        this.displayValidationSummary();
        return;
      }
      this.showLoading(true);

      await CustomerFreightChargeService.save(this.baseView.mode, {
        RecordId: this.model.RecordId,
        CustomerCode: this.model.CustomerCode,
        DeliveryCode: this.model.DeliveryCode,
        UnitOfMeasureCode: this.model.UnitOfMeasureCode,
        FreightCharge: this.model.FreightCharge,
        AllDeliveryAddresses: this.model.AllDeliveryAddresses ? "Y" : "N",
      })
        .then((res) => {
          if (this.baseView.mode == "create") {
            this.model.RecordId = res.data.RecordId;
            this.model.DeliveryCode = res.data.DeliveryCode;
            this.model.FreightCharge = res.data.FreightCharge;
          }

          this.showLoading(false);

          this.$notify(
            `Freight charge for Delivery Address ${this.model.CompanyName} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-freight-charge/review/${this.model.RecordId}`,
          });
          this.baseView.tempId = this.model.CustomerCode;
        })
        .catch((error) => {
          this.displayServerError(
            error,
            "Customer Delivery Address save failed"
          );
        });
    },
    unitOfMeasureCodeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        UnitOfMeasureService.getByCode(params.value).then((response) => {
          if (response.data.value.length > 0) {
            this.model.UnitOfMeasureCode = response.data.value[0].Code;
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
  },
};
</script>
